export const properties = {
  sorry: {
    explanationClassName: 'font-normal',
  },
} as const;
